/* eslint-disable import/no-anonymous-default-export */
import service from './service';
import { UrlBuilder } from './url-builder';

const listByPartner = async (partnerId, premiseId, nameFilter, page, pageSize) => {
  if (!partnerId) return service.emptyPageResult();

  const builder = new UrlBuilder(`/partners/${partnerId}/premises/${premiseId}/alert-receivers`);
  builder.add('name', nameFilter);
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return service.emptyPageResult();
};

const listByParent = async (parentId, premiseId, nameFilter, page, pageSize) => {
  if (!parentId) return service.emptyPageResult();

  const builder = new UrlBuilder(`/parents/${parentId}/premises/${premiseId}/alert-receivers`);
  builder.add('name', nameFilter);
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return service.emptyPageResult();
};

const list = async (premiseId, nameFilter, page, pageSize) => {
  if (!premiseId) return service.emptyPageResult();

  const builder = new UrlBuilder(`/premises/${premiseId}/alert-receivers`);
  builder.add('name', nameFilter);
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return service.emptyPageResult();
};

const listForGeofence = async (geofenceId, nameFilter, page, pageSize) => {
  if (!geofenceId) return service.emptyPageResult();

  const builder = new UrlBuilder(`/geofence/${geofenceId}/alert-receivers`);
  builder.add('name', nameFilter);
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return service.emptyPageResult();
};

const partnerAdd = async (partnerId, premiseId, userId) => {
  if (!partnerId) return service.emptyPageResult();

  const builder = new UrlBuilder(`/partners/${partnerId}/premises/${premiseId}/alert-receivers`);

  const response = await service.post(builder.toString(), {
    premiseId: premiseId,
    userId: userId,
  });

  if (response.status === 200) {
    return response.data;
  }

  return service.emptyPageResult();
};
const add = async (premiseId, userId) => {
  console.error('Add parameters', premiseId, userId);
  const builder = new UrlBuilder(`/premises/${premiseId}/alert-receivers`);

  const response = await service.post(builder.toString(), {
    premiseId: premiseId,
    userId: userId,
  });

  if (response.status === 200) {
    return true;
  }

  return false;
};

const addToGeofence = async (geofenceId, userId) => {
  console.error('Add parameters', geofenceId, userId);
  const builder = new UrlBuilder(`/geofence/${geofenceId}/alert-receivers`);

  const response = await service.post(builder.toString(), {
    userId: userId,
  });

  if (response.status === 200) {
    return true;
  }

  return false;
};

const remove = async (premiseId, userId) => {
  const builder = new UrlBuilder(`/premises/${premiseId}/alert-receivers/${userId}`);

  const response = await service.remove(builder.toString());

  if (response.status === 200) {
    return true;
  }

  return false;
};

const removeFromGeofence = async (geofenceId, userId) => {
  const builder = new UrlBuilder(`/geofence/${geofenceId}/alert-receivers/${userId}`);

  const response = await service.remove(builder.toString());

  if (response.status === 200) {
    return true;
  }

  return false;
};

export default {
  listByPartner,
  listByParent,
  list,
  partnerAdd,
  add,
  remove,
  listForGeofence,
  addToGeofence,
  removeFromGeofence,
};
